// 7.1.13 ToObject(argument)
var defined = require('./_defined');
module.exports = function (it) {
  return Object(defined(it));
};



//////////////////
// WEBPACK FOOTER
// ./~/rc-align/~/core-js/library/modules/_to-object.js
// module id = 1107
// module chunks = 1